<script>
export default {
  props: {
    qa: {
      type: Object,
      default: () => ({}),
    },
  },
}
</script>

<template>
  <div class="qa">
    <div class="qa_question">
      <div class="qa_question-number">{{ qa.numberQuestion }}</div>
      <div class="qa_question-question">
        {{ qa.question }}
      </div>
    </div>
    <div class="qa_answer" v-html="qa.answer"></div>
  </div>
</template>

<style lang="scss" scoped>
@import './question-and-answer.scss';
</style>
